import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import MyIcon from "../Common/MyIcon";
import InfoIcon from "../../assets/icons/Icon_Library/application icons/general/movable.svg2";
import DetailsForSolutionModals from "./DetailsForSolutionModals";
import { SolutionCard } from "../Library/SolutionsCardList";

export default function SolutionInfoModal({ uuid, solution }) {
  const [show, setShow] = useState(false);

  return (
    <>
      <div onClick={() => setShow(true)} className="h-100">
        <SolutionCard solution={solution} />
      </div>
      <Modal size="lg" show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="d-flex align-items-center ">
              <MyIcon
                Icon={InfoIcon}
                width={30}
                className="me-3 rounded-3 svg-white"
              />
              <span className="fs-3 fw-bold">Solution Information</span>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <DetailsForSolutionModals solution={solution} uuid={uuid} />
        </Modal.Body>
      </Modal>
    </>
  );
}
